import { LifeCycle, LifeCycleLabel, TeamActionState } from '../../../types/LC.Types';

export const overviewTiles = [
  {
    name: 'Total',
    url: '/GetTotalCountOfTeams',
    detailsUrl: '/GetAllLifeCycleTeams',
  },
  {
    name: 'Active',
    url: `/GetCountByLifeCycleState/${LifeCycleLabel[LifeCycle.Active]}`,
    detailsUrl: `/GetLifeCycleTeamsByLifeCycleState/${LifeCycleLabel[LifeCycle.Active]}`,
  },
  {
    name: '2 Months',
    url: `/GetCountByActionState/${TeamActionState.TeamNotification2Month}`,
    detailsUrl: `/GetLifeCycleTeamsByActionState/${TeamActionState.TeamNotification2Month}`,
  },
  {
    name: '1 Month',
    url: `/GetCountByActionState/${TeamActionState.TeamNotification1Month}`,
    detailsUrl: `/GetLifeCycleTeamsByActionState/${TeamActionState.TeamNotification1Month}`,
  },
  {
    name: '5 Days',
    url: `/GetCountByActionState/${TeamActionState.TeamNotification5Day}`,
    detailsUrl: `/GetLifeCycleTeamsByActionState/${TeamActionState.TeamNotification5Day}`,
  },
  {
    name: 'Deleted',
    url: `/GetCountByLifeCycleState/${LifeCycleLabel[LifeCycle.Deleted]}`,
    detailsUrl: `/GetLifeCycleTeamsByLifeCycleState/${LifeCycleLabel[LifeCycle.Deleted]}`,
  },
];

export const chartConfigs = [
  {
    type: 'General',
    url: '/GetDataForGeneralChart',
    colors: ['#4caf50', '#ffeb3b', '#f44336'],
  },
  {
    type: 'Category',
    url: '/GetDataForTeamCategoryChart',
    colors: ['#e3f2fd', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5'],
  },
  {
    type: 'Notified',
    url: '/GetDataForNotifiedChart',
    colors: ['#4caf50', '#ff9800', '#9c27b0', '#f44336'],
  },
];
